import React from "react";
import { DebitListForCash } from "@icoach/batchPayment/component";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";

const RentCabinetBatchPaymentExemptedDebitList = () => {
	const { batchPaymentLists, dialogRef, getBatchPayments } = useBatchPaymentContext();

    return <DebitListForCash list={batchPaymentLists?.noPaymentItems || []} dialogRef={dialogRef}
							 refresh={getBatchPayments} />;
};

export default RentCabinetBatchPaymentExemptedDebitList;
